import { CATEGORY_LINKS } from "../../../content/index.content";
import onDemandTraining from "./LearnHowToSellOnAmazon/onDemandTraining";
import monthlyReportsAndTrends from "./AmazonTrendsAndHotProducts/monthlyReportsAndTrends";
import weeklyHotProducts from "./AmazonTrendsAndHotProducts/weeklyHotProducts";
// import freeBonuses from "./AmazonTrendsAndHotProducts/freeBonuses";
import amazonTrainingsAndCourses from "./LearnHowToSellOnAmazon/amazonTrainingsAndCourses";
import OneOnOneMentorCall from "./LearnHowToSellOnAmazon/OneOnOneMentorCall";

export const updateLinks = ({ language, isSavedUser }) => {
  const generateCategory = (category, links) => ({
    category: CATEGORY_LINKS[category],
    links: links.map((link) => link({ language, isSavedUser })),
  });
  return [
    generateCategory("LEARN_HOW_TO_SELL_ON_AMAZON", [
      amazonTrainingsAndCourses,
      OneOnOneMentorCall,
      onDemandTraining,
    ]),
    generateCategory("AMAZON_TRENDS_AND_HOT_PRODUCTS", [
      monthlyReportsAndTrends,
      weeklyHotProducts,
    ]),
  ];
};
